import { useParams } from 'react-router'
import useAPI from '../../hooks/useAPI'
import { TermsModalWrap } from 'src/styles/styledcomponent/component/common'

const TermsModal = (): JSX.Element => {
  const params = useParams()
  const api = useAPI('requestTermsDetail')
  const { data: getTermsDetailData, isSuccess } = api.useSetQuery({
    Telecom: Number(params.telecom),
    Idx: Number(params.termsOrderIdx),
  })
  return (
    <TermsModalWrap active={isSuccess}>
      {getTermsDetailData?.Body && <>
        <h2>{getTermsDetailData?.Body?.TermsTitle}</h2>
        <pre dangerouslySetInnerHTML={{ __html: getTermsDetailData?.Body?.TermsContents || '' }} />
      </>}
    </TermsModalWrap>
  )
}
export default TermsModal
